import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import AppContentRedux from './AppRedux';
import ErrorBoundary from './components/ErrorBoundary';
import RedesignPreview from './components/redesign/RedesignPreview';

function useHashRoute() {
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const onChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return hash;
}

function App() {
  const hash = useHashRoute();
  const isRedesign = hash === '#redesign';

  if (isRedesign) {
    return (
      <ErrorBoundary>
        <RedesignPreview onExit={() => { window.location.hash = ''; }} />
      </ErrorBoundary>
    );
  }

  return (
    <Provider store={store}>
      <ErrorBoundary>
        <AppContentRedux />
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
